import { classNames } from '../../utils/classNames';
import { formatDayOffset, formatDurationRange, formatTime } from './_buildSchedule';
import type { DayGroup, PlanPanelLabels } from './types';

interface ScheduleTimelineProps {
  dayGroups: Array<DayGroup>;
  serveTimeMinutes: number;
  labels?: PlanPanelLabels;
  theme: 'dark' | 'light';
}

export function ScheduleTimeline({
  dayGroups,
  serveTimeMinutes,
  labels,
  theme,
}: ScheduleTimelineProps) {
  const isDark = theme === 'dark';

  return (
    <div className="mt-10">
      {dayGroups.map((group) => (
        <div key={group.dayOffset} className="mt-10 first:mt-0">
          <div
            className={classNames(
              'mb-2 tra-text-web-sub-3',
              isDark ? 'text-neutral-100 print:text-neutral-500' : 'text-neutral-500',
            )}
          >
            {formatDayOffset(group.dayOffset, labels)}
          </div>

          {group.dayOffset === 0 && group.entries.length > 0 && (
            <div
              className={classNames(
                'mb-2 uppercase tra-text-web-heading-6',
                isDark ? 'text-white print:text-neutral-900' : 'text-neutral-900'
              )}
            >
              {formatTime(group.entries[0].startMinutes)}
            </div>
          )}

          <div className="flex flex-col gap-1">
            {group.entries.map((entry, i) => {
              const duration = formatDurationRange(
                entry.durationMinutes,
                entry.durationMaxMinutes,
                labels,
              );
              const minHeight = group.dayOffset === 0 ? Math.min(Math.max(entry.durationMinutes * 0.5, 48), 160) : undefined;
              return (
                <div
                  key={`${entry.label}-${i}`}
                  style={{ minHeight }}
                  className={classNames(
                    'px-4 py-3 border-l-4 border-l-brand-300',
                    isDark ? 'bg-neutral-500 print:bg-warm-100' : 'bg-warm-100',
                  )}
                >
                  <div className="flex flex-row items-center uppercase tra-text-web-body-s">
                    <span
                      className={classNames(
                        'tra-text-web-sub-2 font-bold mr-2',
                        isDark ? 'text-white print:text-neutral-900' : 'text-neutral-900',
                      )}
                    >
                      {entry.label}
                    </span>
                    <span
                      className={classNames(
                        isDark ? 'text-neutral-100 print:text-neutral-500' : 'text-neutral-500',
                      )}
                    >
                      {duration}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      <div
        className={classNames(
          'mt-3 uppercase tra-text-web-heading-6',
          isDark ? 'text-white print:text-neutral-900' : 'text-neutral-900'
        )}
      >
        {formatTime(serveTimeMinutes)}
      </div>
    </div>
  );
}
